import { Flex } from "@chakra-ui/react"
import { APPROVE_AND_CALL_TOKENS, CHAIN_ID } from "@mezo/sdk"

import {
  selectActiveToken,
  selectIsOnEthereumChain,
  useDappSelector,
} from "#/redux-state"
import { SDK_NETWORK } from "#/shared/constants"
import SwitchChainButton from "#/ui-old/Buttons/SwitchChainButton"

import DepositApproveButton from "./DepositApproveButton"
import DepositTokenButton from "./DepositTokenButton"

export default function DepositButtons() {
  const activeToken = useDappSelector(selectActiveToken)

  const hasCorrectChain = useDappSelector(selectIsOnEthereumChain)

  const noApprove =
    activeToken === "BTC" || APPROVE_AND_CALL_TOKENS.includes(activeToken)

  if (!hasCorrectChain)
    return <SwitchChainButton label="deposit" chainId={CHAIN_ID[SDK_NETWORK]} />

  return (
    <Flex
      justifyContent="space-between"
      gap={4}
      flexDir="column"
      alignItems="flex-end"
    >
      {noApprove || <DepositApproveButton />}
      <DepositTokenButton />
    </Flex>
  )
}
